import * as z from "zod";

export function silent<T>(
  schema: z.ZodType<T>,
  defaultValue: Exclude<T, undefined>,
) {
  return schema.default(defaultValue).catch(defaultValue);
}

export function extractLiterals<T extends z.ZodUnion | z.ZodLiteral>(
  schema: T,
) {
  if (schema instanceof z.ZodUnion) {
    return schema.options.flatMap((option) => {
      if (option instanceof z.ZodLiteral) {
        return Array.from(option.values);
      }
      return [];
    });
  } else if (schema instanceof z.ZodLiteral) {
    return Array.from(schema.values);
  }

  return [];
}
